'use client';

import React, { forwardRef } from 'react';
import { motion, type MotionProps } from 'framer-motion';
import { cn } from '@/lib/utils';
import ResponsiveWrapper, {
  type ResponsiveProperties,
} from './responsive-wrapper.tsx';

export interface SectionProperties extends ResponsiveProperties, MotionProps {
  id?: string;
  padding?: string;
  margin?: string;
  background?: string;
  fullWidth?: boolean;
  className?: string;
}

const Section = forwardRef<HTMLSelectElement, SectionProperties>(
  (
    {
      id,
      padding = 'py-6',
      margin = '',
      background = '',
      fullWidth = false,
      sm = 'sm:py-6',
      md = 'md:py-8',
      lg = 'lg:py-12',
      className = '',
      children,
      ...props
    },
    ref,
  ) => {
    const sectionClasses = cn(
      'w-full h-full',
      fullWidth ? '' : 'max-w-7xl mx-auto',
      padding,
      margin,
      background,
      className,
    );

    return (
      <ResponsiveWrapper sm={sm} md={md} lg={lg}>
        <motion.section
          ref={ref}
          id={`SECTION${id ? `-${id}` : ''}`}
          className={sectionClasses}
          {...props}
        >
          {children}
        </motion.section>
      </ResponsiveWrapper>
    );
  },
);

Section.displayName = 'Section';

export default Section;
